import { login } from '../../api/user'

const getDefaultState = () => {
  return {
    token: '',
    username: ''
  }
}

const state = getDefaultState()

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
}

const actions = {
  // 登录
  Login({ commit }, userInfo) {
    const username = userInfo.username.trim()
    const password = userInfo.password

    return new Promise((resolve, reject) => {
      login(userInfo).then(res => {
        if (res.access_token) {
          // 保存 token
          sessionStorage.setItem('TOKEN', res.access_token)
          commit('SET_TOKEN', res.access_token)

          // 保存用户名
          sessionStorage.setItem('USERNAME', username)
          commit('SET_USERNAME', username)

          resolve()
        } else {
          reject(res.resp_msg || '登录出错')
        }

      }).catch(error => {
        reject(error)
      })
    })
  },
  LogOut({ commit, state }) {
    return new Promise((resolve, reject) => {
      sessionStorage.removeItem('TOKEN')
      sessionStorage.removeItem('USERNAME')
      commit('SET_TOKEN', null)
      commit('SET_USERNAME', '')
      resolve()
    })
  },
  // 从 sessionStorage 恢复用户信息
  RestoreUserInfo({ commit }) {
    const token = sessionStorage.getItem('TOKEN')
    const username = sessionStorage.getItem('USERNAME')
    if (token) {
      commit('SET_TOKEN', token)
    }
    if (username) {
      commit('SET_USERNAME', username)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

